import styled from '@emotion/styled';

export const SubHeadlineContainer = styled('div')<{ collapse?: boolean }>`
  color: ${(p) => p.theme.palette.text.secondary};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: ${(p) => (p.collapse ? 0 : p.theme.spacing(4))}px;
  column-gap: ${(p) => p.theme.spacing(3)}px;
  row-gap: ${(p) => p.theme.spacing(.5)}px;
  flex-wrap: wrap;
`;

export const SubHeadLineItem = styled('div')`
  display: flex;
  align-items: center;
  gap: ${(p) => p.theme.spacing(0.5)}px;
  flex-wrap: nowrap;
  & > * {
    min-width: ${(p) => p.theme.spacing(2)}px;
  }
`;
